import Index from '../views/Index.vue'
import Home from '../views/Home.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Index },
  { path: '/home', component: Home },
  { path: '/purchase', component: () => import('../views/Purchase.vue') },
  { path: '/article', component: () => import('../views/Article.vue') },
  { path: '/gonglue', component: () => import('../views/GongluePC.vue') },

]
const router = new VueRouter({
  routes
})

export default router
